<label for="password" class="form-label">
  {{passwordLabel}}
</label>

<div class="input-group form-password-toggle input-group-merge"
  [ngClass]="{ 'warning': shouldShowCapsLockWarning, 'is-invalid': isInValid }">
  <input title="{{title}}" [ngClass]="{ 'is-invalid': isInValid }" class="form-control password-input"
    [type]="passwordFieldType" #input [formControl]="control" autocomplete="new-password" [placeholder]="placeholder"
    (focusout)="onPasswordInputFocusOut()" (focusin)="onPasswordInputFocusin()" (keydown.enter)="onEnter($event)"/>

  <span class="input-group-text cursor-pointer">
    <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': showPassword, 'icon-eye': !showPassword }"
      (click)="toogleMainPasswordVisibility()">
    </i>
  </span>
</div>

<div *ngIf="isInValid" class="invalid-feedback" [innerHtml]="validationErrors"></div>

<div  [ngClass]="{ 
  'caps-lock-feedback': shouldShowCapsLockWarning, 
  'mt-1': shouldShowCapsLockWarning   
  }">  
  <au-notification-bar #notificationBar> </au-notification-bar>
</div>
